var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"width":"25","height":"25","viewBox":"9 3 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19.9299 12.3903L9.42993 18.4525L9.42993 6.32814L19.9299 12.3903Z","fill":"#333333"}})])}
var staticRenderFns = []

export { render, staticRenderFns }